module.exports = __webpack_public_path__ + "static/media/FazzNeue-Italic.68091e51.ttf";